import React from 'react'

import styles from './PopoverContent.module.scss'

export const PopoverContent = React.forwardRef<HTMLDivElement, React.HTMLProps<HTMLDivElement>>(({...props}, ref) => {
  return <div {...props} ref={ref} className={styles.container} />
})

PopoverContent.displayName = "PopoverContent"